import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import EmployeeType from "./EmployeeType";
import EmployeePersonal from "./EmployeePersonal";
import EmployeeAddress from "./EmployeeAddress";
import StepsWizard from "../../../components/templates/StepsWizard";
import {
  createRecord,
  loadGlobalEmployee,
} from "../../employeeDetails/employeeDetailsSlice";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { useLoadScript } from "@react-google-maps/api";
var flatten = require("flat");
var unflatten = require("flat").unflatten;
const libraries = ["places"];

const NewEmployeeWizard = (props) => {
  const { hideWizard, onShowEmployeeCardClicked } = props;
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDs2QkqANgCTQIcThQFCiNkxcKGPVkS_lM",
    libraries: libraries,
    language: "he",
  });
  const dispatch = useDispatch();
  let location = useLocation();
  let { branchId } = useParams();
  let history = useHistory();
  const [nextDisabled, setNextDisabled] = useState(true);
  const [values, setValues] = useState({});
  const loadGlobalLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/loadGlobalEmployee"]
  );
  const createLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/create"]
  );

  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  let slide2Validation =
    values.employee_type_id === 2
      ? [
          "foreign.first_name",
          "foreign.surename",
          "foreign.passport_number",
          "birthday",
          "first_name",
          "gender_id",
          "surename",
        ]
      : ["birthday", "first_name", "gender_id", "surename"];
  if (!branchId) {
    slide2Validation.push("branch");
  }
  const steps = [
    {
      title: null,
      description: null,
      headline: <FormattedMessage id="app.employees.creationHeadline" />,
      subtitle: <FormattedMessage id="app.employees.creationSubtitle" />,
      required: ["employee_type_id"],
      validation: ["employee_type_id"],
      comp: <EmployeeType />,
    },
    {
      title: null,
      description: null,
      headline: null,
      subtitle: <FormattedMessage id="app.employees.personalSubtitle" />,
      required: slide2Validation,
      validation: slide2Validation,
      comp: <EmployeePersonal values={values} />,
    },
    {
      title: null,
      description: null,
      subtitle: <FormattedMessage id="app.employees.addressSubtitle" />,
      required: [],
      validation: [],
      comp: <EmployeeAddress />,
    },
  ];

  const setNext = (val) => {
    setNextDisabled(val);
  };

  const hide = () => {
    setNextDisabled(true);
    setValues({});
    hideWizard();
  };

  const onFinish = async (formValues) => {
    const deepValues = unflatten(formValues);
    deepValues["care_giver"] = true;
    deepValues["local_id_number"] =
      deepValues.local_id_number === ""
        ? null
        : deepValues.local_id_number?.padStart(9, "0");

    const isAdmin = location.pathname.includes("admin");
    let geo = {};

    if (deepValues.address && deepValues.address.city) {
      const address =
        deepValues.address.city +
        ", " +
        deepValues.address.street +
        " " +
        deepValues.address.house_number;
      const p = await getNewAddress(address);

      const geoDetails = await getGeo(p["predictions"]);
      geo = geoDetails;
    }
    const params = {
      employee: { ...deepValues, geo },
      branchId: isAdmin ? values["branch"] : branchId,
    };
    const action = await dispatch(createRecord(params));
    if (!action.error) {
      hide();
      const url = isAdmin
        ? "/admin/employees/" + action.payload.data.id
        : "/branches/" + branchId + "/employees/" + action.payload.data.id;
      history.push(url);
    }
  };

  const getNewAddress = async (address) => {
    const places =
      isLoaded && new window.google.maps.places.AutocompleteService();
    const predictions = await places.getPlacePredictions({
      ...props.searchOptions,
      input: address,
    });
    return predictions;
  };

  const getGeo = async (predictions) => {
    if (predictions && predictions.length > 0) {
      const results = await geocodeByAddress(predictions[0].description);
      const latLng = await getLatLng(results[0]);
      const geo = {
        longtitude: latLng.lng,
        latitude: latLng.lat,
        address_line: predictions[0].description,
      };
      return geo;
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const changeValues = (val) => {
    setValues(val);
  };

  const onValuesChange = async (changedValues, allValues) => {
    const newValues = unflatten(allValues);
    if (
      changedValues.local_id_number ||
      changedValues["foreign.passport_number"]
    ) {
      if (
        isId(changedValues.local_id_number) ||
        isPassport(changedValues["foreign.passport_number"])
      ) {
        const filter = isId(changedValues.local_id_number)
          ? { local_id_number: changedValues.local_id_number?.padStart(9, "0") }
          : { passport_number: changedValues["foreign.passport_number"] };
        const params = {
          scopePrefix,
          filter: {
            ...filter,
          },
        };
        const action = await dispatch(loadGlobalEmployee(params));
        if (action.payload && action.payload.id) {
          const flattenRecord = flatten(action.payload, { safe: true });
          onShowEmployeeCardClicked(flattenRecord, false);
          hideWizard();
        }
      }
    }
    setValues({ ...values, ...newValues });
  };
  const isId = (value) => {
    let strId = String(value).trim();
    if (strId.length > 9 || strId.length < 8) {
      return false;
    }
    if (strId.length < 9) {
      while (strId.length < 9) strId = "0" + strId;
    }
    let counter = 0,
      rawVal,
      actualVal;
    for (let i = 0; i < strId.length; i++) {
      rawVal = Number(strId[i]) * ((i % 2) + 1);
      actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
      counter += actualVal;
    }
    if (counter % 10 === 0) {
      return true;
    } else {
      return false;
    }
  };

  const isPassport = (value) => {
    const isPass = /^(?!^0+$)[a-zA-Z0-9]{6,9}$/.test(value);
    return isPass && value;
  };

  return (
    <StepsWizard
      formLayout={{
        labelCol: { span: 11 },
        wrapperCol: { span: 13 },
      }}
      steps={steps}
      values={values}
      onCancel={hide}
      onValuesChange={onValuesChange}
      setNext={setNext}
      changeValues={changeValues}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={hide}
      saveLoading={createLoading}
      createText={<FormattedMessage id="app.employees.createNewEmployee" />}
      nextDisabled={nextDisabled || loadGlobalLoading}
    />
  );
};

export default NewEmployeeWizard;
